
import { defineComponent } from 'vue';
import AdListItemColumns from './AdListItemColumns.vue';
import AdListItemRows from './AdListItemRows.vue';
import AdListItemFullScreen from './AdListItemFullScreen.vue';
import AdListItemTable from './AdListItemTable.vue';
import AdListItemMobile from './AdListItemMobile.vue';
import { mapGetters } from 'vuex';

export default defineComponent({
  name: 'AdListItem',
  emits: ['selected', 'hover'],
  props: {
    ad: Object,
    viewType: String,
    isActive: Boolean,
  },
  components: {
    AdListItemColumns,
    AdListItemRows,
    AdListItemFullScreen,
    AdListItemTable,
    AdListItemMobile,
  },
  data() {
    return {
      isMounted: false,
      imageLimitCount: 1,
    };
  },
  computed: {
    ...mapGetters(['zoomAds', 'windowWidth']),
  },
  watch: {
    zoomAds: function () {
      this.updateImageLimitCount();
    },
    windowWidth: function () {
      this.updateImageLimitCount();
    },
    viewType: function () {
      this.updateImageLimitCount();
    },
  },
  mounted() {
    this.isMounted = true;
    this.updateImageLimitCount();
  },
  methods: {
    updateImageLimitCount() {
      this.$nextTick(() => {
        this.imageLimitCount = this.getImageLimitCount();
      });
    },
    getImageLimitCount(): number {
      if (!this.isMounted) {
        return 1;
      }

      const parentWidth = (this.$refs.element as any).clientWidth;

      if (this.viewType === 'table') {
        const minimumWidthToAdd = 2200;
        const nextImageWidth = 1000;
        return 1 + Math.ceil((this.$store.state.windowWidth - minimumWidthToAdd) / nextImageWidth);
      } else if (this.viewType === 'rows') {
        const minimumWidthToAdd = 800;
        const nextImageWidth = 250;
        const result = 2 + Math.ceil((parentWidth - minimumWidthToAdd) / nextImageWidth);
        return result;
      } else if (this.viewType === 'fullscreen') {
        return 2;
      }
      return 1;
    },
    onClick() {
      this.$emit('selected', this.ad);
    },
    onMouseOver() {
      this.$emit('hover', this.ad);
    },
    onMouseLeave() {
      this.$emit('hover', null);
    },
  },
});
